import React, { useEffect, useState } from 'react'
import {
  BlockingLoader,
  Container,
  Icon64,
  Tabs,
  TextBody,
  TextTitle,
  ToastContext,
  Button,
  Icon,
  Sticky,
  Css
} from '@pdrj/pmi-iqos-ds-react'
import {
  parseTranslations,
  PublishedComponent,
  htmlTranslation,
  goTo,
  extractErrorMessage,
  analytics
} from '@pdrj/pmi-iqos-shared-react'
import { getInitialPropsMock, mapPrizeToProduct } from '@iqosphere-common/utils'
import { LoyaltyProductList } from '@iqosphere-common/components'
import { api } from '@iqosphere-common/services'
import CampaignTranslations from './campaign.json'

const CampaignComponent = ({
  campaignName,
  cta,
  isCarousel,
  showSectionTitle,
  subText,
  title,
  productDataList,
  bauPath,
  translations,
  miniPlpAlignment,
  plpView = 'compact',
  hasLoyaltyBar,
  campaignCode,
  reqProps
}) => {
  const [selectedTabItemIndex, setSelectedTabItemIndex] = useState(0)
  const [loading, setLoading] = useState()
  const [productLists, setProductLists] = useState({})

  const sections = {
    exchange: 'exchange',
    lottery: 'lottery'
  }
  const tabItems = [
    {
      label: translations.tk_tab1,
      additionalTemplate: (
        <Container pb="4">
          <Icon64 image={Icon64.images.rewards} size={Icon64.sizes.l} />
        </Container>
      ),
      section: sections.lottery
    },
    {
      label: translations.tk_tab2,
      additionalTemplate: (
        <Container pb="4">
          <Icon64 image={Icon64.images.rewards2} size={Icon64.sizes.l} />
        </Container>
      ),
      section: sections.exchange
    }
  ]

  useEffect(() => {
    setLoading(true)
    const productMap = {
      [sections.exchange]: {
        title: tabItems[1].label,
        products: []
      },
      [sections.lottery]: {
        title: tabItems[0].label,
        products: []
      }
    }
    const mappedProductDataList = productDataList.map(productData => ({
      ...mapPrizeToProduct(productData)
    }))
    mappedProductDataList.forEach(({ product }) => {
      const section = product && product.loyalty && product.loyalty.section
      section &&
        productMap[section] &&
        productMap[section].products.push(product)
    })
    setProductLists({ ...productMap })

    const findIndex = tabItems.findIndex(
      t => productMap[t.section] && productMap[t.section].products.length
    )
    setSelectedTabItemIndex(findIndex === -1 ? 0 : findIndex)

    setLoading(false)
  }, [])

  const handleClickTab = newSelectedTabItemIndex => {
    if (selectedTabItemIndex !== newSelectedTabItemIndex) {
      setSelectedTabItemIndex(newSelectedTabItemIndex)
    }
  }

  const handleClickFurtherDetails = cta => {
    const eventCategory = analytics.getEventCategory()
    const eventLabel =
      cta &&
      cta.options &&
      cta.options.attributes &&
      cta.options.attributes['ga-label']

    if (eventCategory && eventLabel) {
      analytics.clickEvent({
        eventCategory,
        eventLabel
      })
    }
    goTo(cta.uri)
  }

  const displayTabs =
    Object.keys(sections)
      .map(
        section =>
          productLists[section] && productLists[section].products.length > 0
      )
      .filter(Boolean).length === Object.keys(sections).length

  const currentSection = tabItems[selectedTabItemIndex].section
  let currentSectionMap
  if (displayTabs) {
    currentSectionMap = productLists && productLists[currentSection]
  } else {
    if (
      productLists[sections.exchange] &&
      productLists[sections.exchange].products.length
    ) {
      currentSectionMap = productLists[sections.exchange]
    } else if (
      productLists[sections.lottery] &&
      productLists[sections.lottery].products.length
    ) {
      currentSectionMap = productLists[sections.lottery]
    }
  }
  const currentTitle = currentSectionMap && currentSectionMap.title
  const currentProducts = (currentTitle && currentSectionMap.products) || []

  const BuildCardList = ({ isCarousel }) => {
    return (
      <Container fullWidth overflowHidden>
        {!showSectionTitle && (
          <TextTitle heading={TextTitle.headings.h3}>{currentTitle}</TextTitle>
        )}
        {currentProducts.length > 0 ? (
          <Container pt="8">
            <LoyaltyProductList
              columns={[plpView === 'compact' ? 2 : 1, 2, 3, 4]}
              plpView={plpView}
              products={currentProducts}
              alternative={currentSection === sections.exchange}
              campaignName={campaignName}
              translations={translations}
              isCarousel={isCarousel}
              productBaseUrl={bauPath}
              miniPlpAlignment={miniPlpAlignment}
              campaignCode={campaignCode}
            />
          </Container>
        ) : currentSectionMap ? (
          <Container pt="8">
            <TextBody {...htmlTranslation(translations, 'tk_noProducts')} />
          </Container>
        ) : (
          []
        )}
      </Container>
    )
  }

  return (
    <Container position={Container.positions.relative}>
      {loading && <BlockingLoader loading />}
      {showSectionTitle && (
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          justifyContent={Container.justifyContentValues.center}>
          <TextTitle alignment={TextTitle.alignments.center}>{title}</TextTitle>
          <Container layout={Container.layouts.small} pt="8" pb="12">
            <TextBody acceptsHtml value={subText} />
          </Container>
        </Container>
      )}
      {displayTabs ? (
        <>
          <Sticky
            bg={Sticky.backgrounds.white}
            position={Sticky.positions.sticky}
            zIndex="10"
            fullWidth
            followNavBar={true}
            l="0"
            t="0">
            <Css
              s={{
                paddingTop: hasLoyaltyBar ? '5rem' : '1rem'
              }}>
              <Tabs
                items={tabItems.map((tabItem, index) => ({
                  tabName: tabItem.label,
                  additionalTemplate: tabItem.additionalTemplate,
                  tabIndex: index
                }))}
                isItemSelected={e => e.tabIndex === selectedTabItemIndex}
                getItemLabel={e => e.tabName}
                onItemSelectedHandler={e => handleClickTab(e.tabIndex)}
                getAdditionalTemplate={item => item.additionalTemplate}
                data-testing="ProfileQoins_Tabs"></Tabs>
            </Css>
          </Sticky>

          {selectedTabItemIndex >= 0 && (
            <Container fullWidth pt="8">
              <BuildCardList isCarousel={isCarousel} />
            </Container>
          )}
        </>
      ) : (
        <BuildCardList isCarousel={isCarousel} />
      )}
      {cta && cta.uri && cta.title && (
        <Container
          pt={['0', '8']}
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.center}>
          <Button
            variant={Button.variants.tertiary}
            text={cta.title}
            onClickHandler={() => handleClickFurtherDetails(cta)}
            icon={Icon.images.arrowRight}
            iconPosition={Button.iconPositions.right}
          />
        </Container>
      )}
    </Container>
  )
}

const Campaign = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={CampaignComponent}
        {...ComponentDefaultProps}
        {...props}
        mainLayout
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...CampaignTranslations
}

const ComponentDefaultProps = {
  componentName: 'Campaign',
  translations: {
    ...parseTranslations(ComponentTranslations, true)
  }
}

Campaign.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: async () => {
      const title = (req.body.extra && req.body.extra.title) || ''
      const subText = (req.body.extra && req.body.extra.sub_text) || ''
      const cta = (req.body.extra && req.body.extra.cta) || {}
      const showSectionTitle =
        (req.body.extra && req.body.extra.show_section_title) || ''
      const isCarousel = req.body.extra && req.body.extra.is_carousel
      const campaignName =
        req && req.query && req.query.mock === 'true'
          ? 'campaignName'
          : (req.body.extra && req.body.extra.campaign) || ''
      const campaignCode =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('campaignId')
          : (req.query && req.query.campaign_code) || ''
      const bauPath =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('bauPath')
          : (req.body.extra && req.body.extra.bau_path) || null

      const miniPlpAlignment =
        req && req.query && req.query.mock === 'true'
          ? 'center'
          : (req.query && req.query.mini_plp_alignment) || null

      const plpView =
        req && req.query && req.query.mock === 'true'
          ? ''
          : (req.query && req.query.mini_plp_view) || null

      const hasLoyaltyBar =
        req && req.query && req.query.mock === 'true'
          ? ''
          : (req.body.extra && req.body.extra.has_loyalty_bar) || null

      let res = null
      let error = null

      try {
        res = await api.iqospherePrize.getPrizesCampaign(campaignCode)
      } catch (err) {
        const message = extractErrorMessage(err)
        // since API GW does not send us a proper 404 we need to treat in a special way this error
        // in order for Drupal to send a proper 404
        if (message === 'Product not available') {
          return {
            error: {
              message,
              status: 404
            }
          }
        } else if (err.data && err.data.data && err.data.data.products) {
          error = {
            message: err.data.message,
            status: err.status
          }
        } else {
          throw err
        }
      }

      const productDataList = res?.prizes
      if (!productDataList) {
        return {
          error: {
            message: 'Product List not available',
            status: 404
          }
        }
      }
      return {
        campaignName,
        title,
        subText,
        cta,
        showSectionTitle,
        isCarousel,
        error,
        productDataList,
        bauPath,
        miniPlpAlignment,
        plpView,
        hasLoyaltyBar,
        campaignCode,
        reqProps: {
          query: req.query,
          extra: req.body.extra
        }
      }
    }
  })
}

export default Campaign
